export class EngagementGraph {
    static jsonMap = {
        libelleRefStatut: { key: 'libelleRefStatut', optional: true, default: '' },
        codeRefStatut: { key: 'codeRefStatut', optional: true, default: '' },
        value: { key: 'value', optional: true }
    };

    public libelleRefStatut: string = undefined;
    public codeRefStatut: string = undefined;
    public value: number = undefined;
}
